import React from 'react';

import * as RunHooks from '../../../state/runs/hooks';
import {useIsPanelEditButtonVisible} from '../../Panel/hooks/useIsPanelEditButtonVisible';
import {usePanelContext} from '../../Panel/PanelContextProvider';
import {EditPanelWithModalButton} from '../../Panel/PanelEditButton';
import {usePanelsSharedRefsContext} from '../../Views/contexts/PanelsSharedRefsContext';

export const ReportPanelEditButton = () => {
  // Reports can support multiple run sets, so we need to grab the entity name
  // from the refs rather than from the report URL
  const {runSetRefs} = usePanelsSharedRefsContext();
  const {entityName} = RunHooks.useRunSetsQuery({runSetRefs});

  const {panel} = usePanelContext();
  const isPanelEditButtonVisible = useIsPanelEditButtonVisible(
    entityName,
    panel.viewType
  );

  if (!isPanelEditButtonVisible) {
    return null;
  }

  return <EditPanelWithModalButton buttonSize="sm" />;
};
